import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x6901,
  properties: ["read", "write", "notify"],
};
export function generateMockDURNofifyData(): DomianControl.TAANotifyData {
  const data = getMockDataByKeys(
    [
      // 横摆速度
      "UIRx_ACUYawRate",
      // // 方向盘转角
      "UIRx_SBW_HWAAng",
      // // TAA激活状态
      // "UIRx_TAAAct",
    ]
    // {
    //   UIRx_ACULatAcc:[-1, 1],
    //   UIRx_ACULongdAcc:[-1, 1],
    //   UIRx_ACUYawRate:[-75, 75],
    //   UIRx_DeltaOff_FA:[-5, 5],
    //   UIRx_SBW_HWAAng:[-500, 500],
    //   UIRx_DeltaOff_RA:[-5, 5],
    //   UIRx_alphaRA:[-5, 5],
    //   UIRx_WhlBrkTqAct_FL_BCh1:[0, 2000],
    //   UIRx_WhlBrkTqAct_FR_BCh1:[0, 2000],
    //   UIRx_WhlBrkTqAct_RL_BCh1:[0, 2000],
    //   UIRx_WhlBrkTqAct_RR_BCh1:[0, 2000],
    // }
  );
  return data;
}